export default "__VITE_PUBLIC_ASSET__006d7282__"